import { Logout } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleIcon from '@mui/icons-material/People';
import StarIcon from '@mui/icons-material/Star';
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { User, signOut } from 'firebase/auth';
import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { auth } from '../firebaseSetup';
import { Paths } from '../routes/paths';

interface NavButton {
  name: string;
  path: Paths;
  icon?: JSX.Element;
}

const MainLayout: React.FC<{ user: User }> = ({ user }) => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const pages: NavButton[] = [
    { name: 'Žáci', path: Paths.Students, icon: <PeopleIcon /> },
    {
      name: 'Úprava hodnocení',
      path: Paths.RatingSentencesEdit,
      icon: <StarIcon />,
    },
  ];

  const handleLogout = () => signOut(auth).then(() => navigate(Paths.Login));

  return (
    <>
      <AppBar position="sticky">
        <Container maxWidth="xl">
          <Toolbar>
            <Box display="flex" justifyContent="space-between" width="100%">
              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  onClick={(event) => setAnchorElNav(event.currentTarget)}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorElNav}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  keepMounted
                  open={Boolean(anchorElNav)}
                  onClose={() => setAnchorElNav(null)}
                  sx={{ display: { xs: 'block', md: 'none' } }}
                >
                  {pages.map((page) => (
                    <MenuItem
                      key={page.name}
                      onClick={() => {
                        setAnchorElNav(null);
                        navigate(page.path);
                      }}
                    >
                      {page.icon}
                      <Typography textAlign="center" ml={2}>
                        {page.name}
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
              <Box display="flex" alignItems="center" mr={2}>
                <Typography
                  variant="h4"
                  className="Logo"
                  fontSize={{ xs: '2rem', sm: '2.4rem' }}
                  sx={{ letterSpacing: '.1rem' }}
                >
                  TukTuk
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {pages.map((page) => (
                  <Button
                    key={page.name}
                    onClick={() => navigate(page.path)}
                    color="inherit"
                    style={{ fontSize: '1.1rem' }}
                    size="large"
                  >
                    {page.icon}
                    <Box ml={1} />
                    {page.name}
                  </Button>
                ))}
              </Box>

              <Box display="flex" alignItems="center">
                <Typography
                  mr={1}
                  variant="h6"
                  noWrap
                  sx={{
                    display: { xs: 'none', md: 'inherit' },
                    fontSize: '1.2rem',
                  }}
                >
                  {user.displayName ?? user.email}
                </Typography>
                <Tooltip title="Odhlásit se" arrow>
                  <IconButton color="inherit" onClick={handleLogout}>
                    <Logout />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="xl" sx={{ p: { xs: 1, sm: 2, md: 3, lg: 4 } }}>
        <Outlet />
      </Container>
    </>
  );
};

export default MainLayout;
